module.exports = __webpack_public_path__ + "static/media/ET.84372825.svg";